<template>
  <div class="personal-data-component">
    <div class="personal-data">
      <ProfileNavbar></ProfileNavbar>
      <div class="data-wrap">
        <div class="account-safe">
          <div class="option-item">
            <div class="item-L">
              <div class="icon"></div>
              <div class="info">
                <div class="title">登录密码</div>
                <div class="desc">用于保护账户安全</div>
              </div>
            </div>
            <router-link :to="{ path: '/user/password' }" class="action">设置密码</router-link>
          </div>
          <div class="option-item">
            <div class="item-L">
              <div class="icon"></div>
              <div class="info">
                <div class="title">支付密码</div>
                <div class="desc">用户保护资金安全</div>
              </div>
            </div>
            <router-link :to="{ path: '/user/pay_password' }" class="action">设置支付密码</router-link>
          </div>
          <div class="option-item">
            <div class="item-L">
              <div class="icon"></div>
              <div class="info">
                <div class="title">手机</div>
                <div class="desc">用户登录、找回密码、安全认证</div>
              </div>
            </div>
            <div class="phone">{{ user.phone }}</div>
            <router-link :to="{ path: '/user/phone' }" class="action">更换手机号</router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getIndex } from "@/api/user";
import ProfileNavbar from "@/components/profileNavbar"

export default {
  name: 'UserAccount',
  components: {
    ProfileNavbar
  },
  data() {
    return {
      loading: true,
      user: {}
    };
  },
  computed: {

  },
  created() {
    this.getIndex();
  },
  methods: {
    getIndex() {
      getIndex({}).then(res => {
        this.loading = false;
        this.user = res.data.user;
      }).catch((err) => {

      });
    },
  }
};
</script>

<style lang="scss" scoped>
.personal-data-component {
  width: 100%;

  .resetPassword-wrap {
    width: 100%;
    display: flex;
    align-items: center;
    flex-direction: column;
    background: #FFFFFF;
    box-shadow: 0px 0px 10px 1px rgba(111, 127, 132, 0.102);
    border-radius: 2px;
    margin-top: 16px;

    .title {
      font-size: 16px;
      font-weight: bold;
      color: #222222;
      width: 100%;
      box-sizing: border-box;
      padding: 27px 0;
      border-bottom: 1px solid #CCD7DB;
      text-align: center;
    }

    .reset-form {
      width: 100%;
      padding: 50px 0 62px 0;
      box-sizing: border-box;
      display: flex;
      align-items: center;
      flex-direction: column;

      .login-msg {
        width: 345px;
        display: flex;
        flex-direction: column;
        row-gap: 20px;
        margin-bottom: 35px;

        .username-inp,
        .pwd-inp,
        .phone-inp,
        .code-inp,
        .new-pwd-inp {
          display: grid;
          grid-template-columns: 63px auto;
          align-items: center;
          column-gap: 15px;
          width: 345px;
          height: 50px;
          border-radius: 4px;
          box-sizing: border-box;
          border: 0.6px solid #CCD7DB;

          &>.icon {
            width: 62px;
            height: 50px;
            border-right: 0.6px solid #CCD7DB;

            &>img {
              width: 25px;
              height: 25px;
            }
          }

          &>#username,
          #pwd,
          #code,
          #phone,
          #newPwd {
            width: calc(100% - 15px);
            border: none;
            outline: none;
            background-color: transparent;
          }

          &>.pwd-eye {
            width: 25px;
            height: 50px;
            cursor: pointer;

            &>img {
              width: 25px;
              height: 25px;
            }
          }
        }

        .btn-list {
          width: 345px;
          display: flex;
          align-items: center;
          justify-content: space-between;

          .submit {
            width: 150px;
            height: 40px;
            background: #00B4E8;
            border-radius: 20px;
            font-size: 14px;
            font-weight: 300;
            color: #FFFFFF;
            cursor: pointer;
          }

          .cancel {
            width: 150px;
            height: 40px;
            border-radius: 20px;
            border: 1px solid #00B4E8;
            font-size: 14px;
            font-weight: 300;
            color: #00B4E8;
            cursor: pointer;
          }
        }

        .pwd-inp {
          padding-right: 19px;
          grid-template-columns: 63px auto 25px;

          #pwd {
            width: 100% !important;
          }
        }

        .code-inp {
          grid-template-columns: 63px auto 121px;

          .send-code-btn {
            height: 50px;
            font-size: 16px;
            font-weight: 400;
            color: #6F7F84;
            background: #CCD7DB;
            border-radius: 0px 4px 4px 0px;
            cursor: pointer;
          }
        }
      }
    }
  }

  .personal-data {
    width: 100%;
    margin-top: 16px;
    background: #FFFFFF;
    box-shadow: 0px 0px 10px 1px rgba(111, 127, 132, 0.102);
    border-radius: 2px;
    padding: 33px 27px 25px 27px;
    box-sizing: border-box;

    .data-type-wrap {
      display: flex;
      align-items: center;
      column-gap: 25px;

      .item {
        padding: 12px 35px;
        background: #D4EEF6;
        font-size: 16px;
        font-weight: 400;
        color: #00B4E8;
        border-radius: 4px;
        cursor: pointer;
      }

      .active {
        background: #00B4E8;
        color: #FFFFFF;
      }
    }

    .data-wrap {
      width: 100%;
      padding: 30px 0;
      box-sizing: border-box;
      background: #FFFFFF;
      border-radius: 4px 4px 4px 4px;
      opacity: 1;
      border: 1px solid #00B4E8;
      margin-top: 27px;
      display: flex;
      align-items: center;
      flex-direction: column;

      .base-info-wrap {
        .user-type-wrap {
          display: flex;
          align-items: center;
          column-gap: 25px;

          .item {
            padding: 12px 35px;
            font-size: 16px;
            font-weight: 400;
            color: #A0A9AC;
            border: 1px solid #A0A9AC;
            cursor: pointer;
          }

          .active {
            border: 1px solid #00B4E8;
            color: #00B4E8;
          }
        }

        .form-wrap {
          width: 95%;
          margin-top: 31px;

          .form-item {
            grid-template-columns: 2fr 8fr;
          }

          .col-form-label {
            text-align: right;
          }
        }
      }

      .address-info-wrap {
        width: 100%;
        padding: 0 20px;
        box-sizing: border-box;

        .empty {
          font-size: 14px;
          font-family: Source Han Sans SC VF, Source Han Sans SC VF;
          font-weight: 400;
          color: #CCD7DB;
          padding-bottom: 18px;
          padding-top: 6px;
          border-bottom: 1px solid #CCD7DB;

          &>i {
            color: #00B4E8;
            cursor: pointer;
          }
        }

        .add-address-wrap {
          display: flex;
          column-gap: 8px;
          align-items: center;
          font-size: 16px;
          font-weight: 400;
          color: #00B4E8;
          border-top: 1px solid #CCD7DB;
          padding-top: 25px;
          padding-left: 25px;
          cursor: pointer;
          box-sizing: border-box;

          .add-icon {
            width: 32px;
            height: 32px;
            background: #F5F9FA;
            border-radius: 4px;
            border: 1px dotted #00B4E8;
            font-size: 35px;
            color: #00B4E8;
            font-weight: bold;
            display: flex;
            align-items: flex-end;
            justify-content: center;
          }
        }

        .address-count-tip {
          width: 100%;
          font-size: 14px;
          font-weight: 400;
          color: #333333;
          text-align: left;
          margin-bottom: 25px;
        }

        thead {
          tr {
            th {
              background-color: #E9F3F6;
            }

            th:nth-child(1) {
              width: 15%;
            }

            th:nth-child(2) {
              width: 15%;
            }

            th:nth-child(3) {
              width: 50%;
            }

            th:nth-child(4) {
              width: 20%;
            }
          }
        }

        tbody {
          tr {
            th:last-child {
              display: flex;
              align-items: center;
              column-gap: 10px;
              justify-content: center;

              span {
                cursor: pointer;
              }
            }
          }
        }

        th {
          text-align: center;
          padding: 13px 0;
        }
      }

      .account-safe {
        display: flex;
        align-items: center;
        flex-direction: column;
        width: 908px;
        row-gap: 20px;

        .option-item {
          display: flex;
          align-items: center;
          justify-content: space-between;
          width: 100%;
          padding: 10px 45px 10px 26px;
          box-sizing: border-box;
          background: #E9F3F6;
          border-radius: 4px;

          .item-L {
            display: flex;
            align-items: center;

            .icon {
              width: 25px;
              height: 25px;
            }

            .info {
              font-size: 14px;
              font-weight: 400;
              color: #A0A9AC;
              margin-left: 21px;

              .title {
                color: #333333;
              }

              .desc {
                color: #A0A9AC;
                margin-top: 5px;
              }
            }
          }

          .phone {
            font-size: 14px;
            font-weight: 400;
            color: #333333;
          }

          .action {
            font-size: 14px;
            font-weight: 400;
            color: #00B4E8;
            cursor: pointer;
          }
        }
      }
    }

    #addAddressModal {
      .col-form-label {
        text-align: right;
      }
    }
  }
}
</style>
